import { maybe } from './util'
import { now } from './helpers'
import { isLoomiParam } from '../analytics/core/util/helpers'

export interface TrafficSource {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
  ts: Date;
}

const lmi_utm_data = 'lmi_utm_data'

function parseTrafficSource(trafficSource: Record<string, string>) {
  if (isEmpty(trafficSource)) {
    return null
  }
  const _trafficSource = {} as TrafficSource
  if (!!trafficSource.campaign) {
    _trafficSource.campaign = trafficSource.campaign
  }
  if (!!trafficSource.medium) {
    _trafficSource.medium = trafficSource.medium
  }
  if (!!trafficSource.source) {
    _trafficSource.source = trafficSource.source
  }
  if (!!trafficSource.term) {
    _trafficSource.term = trafficSource.term
  }
  if (!!trafficSource.content) {
    _trafficSource.content = trafficSource.content
  }
  return _trafficSource
}

function isEmpty(trafficSource?: Record<string, string> | undefined) {
  return !trafficSource || JSON.stringify(trafficSource) === '{}'
}

const UTM_TYPES: Record<string, string> = {
  utm_source: 'source',
  utm_medium: 'medium',
  utm_campaign: 'campaign',
  utm_term: 'term',
  utm_content: 'content',
}

const safeDecode = (val: string, maxAttempts = 3) => {
  let decoded = val
  for (let i = 0; i < maxAttempts; i++) {
    try {
      const next = decodeURIComponent(decoded)
      if (next === decoded) break
      decoded = next
    } catch {
      break
    }
  }
  return decoded
}

export const parseQueryParms = (qs: string = window.location.search) => {
  const result = {
    utm: {} as Record<string, string>,
    lmi_params: {} as Record<string, any>,
  }

  maybe(() => new URLSearchParams(qs))!.forEach((val, name) => {
    if (val) {
      const utm = UTM_TYPES[name]
      const decodedVal = safeDecode(val)
      if (utm) {
        result.utm[utm] = decodedVal
      } else if (isLoomiParam(name)) {
        result.lmi_params[name] = decodedVal
      }
    }
  })
  return result
}

export function getTrafficSources() {
  const utmInfo = maybe(() => parseQueryParms().utm)
  const trafficSource = parseTrafficSource(utmInfo!)
  const pastTrafficSources = getPastTrafficSources(trafficSource)
  localStorage.setItem(lmi_utm_data, JSON.stringify(pastTrafficSources))
  return pastTrafficSources
}

function getPastTrafficSources(trafficSource: TrafficSource | null) {
  let ret: Array<TrafficSource> = []
  const storedSources = localStorage.getItem(lmi_utm_data)
  if (storedSources != null) {
    ret = [...(JSON.parse(storedSources) as Array<TrafficSource>)].slice(0, 20)
  }
  if (!!trafficSource) {
    trafficSource.ts = now()
    ret = [trafficSource, ...ret]
  }
  return ret
}

export function lastUtmCampaign() {
  const trafficSources = getTrafficSources()
  return maybe(() => trafficSources
    .filter(t => t.campaign)
    .reduce((max, current) => current.ts > max.ts ? current : max, trafficSources[0]).campaign) || ''
}
